module.exports = __webpack_public_path__ + "img/keyboard_Arrow.55a372c5.png";